import { getAssetUrl } from '@lighthouse/assets'
import { BlockType } from '@lighthouse/core'
import { BlockThumbImageMap } from '@lighthouse/shared'

import type { BlockTree, BlockTreeItem } from '../type'
import { BlockKind } from '../type'

const blockButton: BlockTreeItem = {
    name: '按钮',
    icon: 'BlockButton',
    describeImage: BlockThumbImageMap['button'],
    backGroundColor: 'rgba(255, 183, 74, 0.10)',
    color: '#FFB74A',
    type: BlockType.button
}

const blockIconButton: BlockTreeItem = {
    name: '图标按钮',
    icon: 'BlockButton',
    describeImage: getAssetUrl('blocks', 'icon_button.svg'),
    backGroundColor: 'rgba(255, 183, 74, 0.10)',
    color: '#FFB74A',
    type: 'iconButton'
}
const blockCapsuleButton: BlockTreeItem = {
    name: '胶囊按钮',
    icon: 'BlockButton',
    describeImage: getAssetUrl('blocks', 'capsule_button.svg'),
    backGroundColor: 'rgba(255, 183, 74, 0.10)',
    color: '#FFB74A',
    type: 'capsuleButton'
}

const blockSwitchButton: BlockTreeItem = {
    name: '开关按钮',
    icon: 'Switch',
    describeImage: getAssetUrl('blocks', 'switch_button.svg'),
    backGroundColor: 'rgba(255, 183, 74, 0.10)',
    color: '#FFB74A',
    type: 'onOff'
}

export const allButton: BlockTree = {
    id: BlockKind.button,
    name: '按钮',
    // icon: 'Button',
    color: '',
    items: [blockButton, blockIconButton, blockCapsuleButton, blockSwitchButton]
}
